module.exports = __webpack_public_path__ + "img/logo.374b5fd9.png";